<script lang="ts">
	import { format } from 'svelte-i18n';
	import TemplateToggleSettings from '../Components/TemplateToggleSettings.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<TemplateToggleSettings
	{device}
	setting="child_lock"
	title={$format('enable_kids_protection', {
		default: 'Enable kids protection',
	})}
/>
